import VariablePlugin from './VariablePlugin';

export * from './Variable';
export default VariablePlugin;
